import { render, staticRenderFns } from "./RemoveMember.vue?vue&type=template&id=14ad9644"
import script from "./RemoveMember.vue?vue&type=script&lang=js"
export * from "./RemoveMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports